import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  count: 0,
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setCount(state, action) {
      state.count = action.payload;
    },
  },
});

export const { setCategories, setLoading, setCount } = categoriesSlice.actions;

export default categoriesSlice.reducer; 